// Árbol de navegación — ÚNICA fuente de verdad del sidebar, las pestañas
// internas y el mapa vista→ruta. Portado literalmente desde app/app.js
// (líneas 29-108) para no perder ninguna entrada.

export type Vista =
  | "hoy" | "resumen" | "embudo" | "atribucion" | "talleres" | "vendedores"
  | "operacion" | "comunidad" | "abandonos" | "higiene" | "calidad"
  | "marketplaces" | "tiendas" | "tiktok" | "google_ads" | "chatgpt_ads"
  | "canales_comparativa" | "klaviyo" | "campanas_ghl" | "marketing_resumen"
  | "reputacion" | "conmutador" | "ml_bot" | "bot_espejo" | "seo" | "clientes-riesgo" | "clientes-pareto"
  | "clientes-recurrentes" | "clientes-dormidos" | "compras_slp" | "espejo_ventas" | "usuarios" | "perfil"
  | "proximamente" | "oficina" | "metas_ventas" | "parrilla" | "marketplaces_abasto";

export interface NavTab {
  vista: Vista;
  label: string;
  badge?: string;
}

export interface NavPage {
  id: string;
  /** Subtítulo dentro de su carpeta ("Atender hoy", "Resultados"…). Solo visual. */
  seccion?: string;
  label: string;
  labelMovil?: string;
  icon?: string;
  kind: "page";
  vista: Vista;
  badge?: string;
}

export interface NavGroup {
  id: string;
  seccion?: string;
  label: string;
  labelMovil?: string;
  icon?: string;
  kind: "group";
  tabs: NavTab[];
}

export interface NavPlaceholder {
  id: string;
  seccion?: string;
  label: string;
  labelMovil?: string;
  icon?: string;
  kind: "placeholder";
  desc?: string;
  plan?: string[];
  star?: boolean;
  nota?: string;
}

export interface NavFolder {
  id: string;
  label: string;
  labelMovil?: string;
  icon?: string;
  kind: "folder";
  children: NavNodo[];
}

export type NavNodo = NavPage | NavGroup | NavPlaceholder | NavFolder;

// vistas reales, en orden
export const VISTAS: Vista[] = ["hoy", "resumen", "embudo", "atribucion", "talleres", "vendedores", "operacion", "comunidad", "abandonos", "higiene", "calidad", "marketplaces", "tiendas", "tiktok", "google_ads", "chatgpt_ads", "canales_comparativa", "klaviyo", "campanas_ghl", "marketing_resumen", "reputacion", "conmutador", "ml_bot", "bot_espejo", "seo", "clientes-riesgo", "clientes-pareto", "clientes-recurrentes", "clientes-dormidos", "compras_slp", "espejo_ventas", "parrilla", "usuarios", "perfil", "proximamente", "oficina", "metas_ventas", "marketplaces_abasto"];

// vistas personales/administrativas: sin filtros de fechas/sucursal ni encabezado del radar
// La oficina de agentes trae sus propios filtros (sucursal, urgencia): las fechas no le aplican.
// Metas de Venta trae su propio selector de trimestre.
export const VISTAS_SIN_FILTROS: Vista[] = ["hoy", "usuarios", "perfil", "proximamente", "oficina", "metas_ventas"];

// vistas cuyos datos son globales (cuentas de ads, marketplaces, etc.): el filtro
// de sucursal no les aplica — el selector se deshabilita para no dar impresión
// de que filtra cuando no
export const VISTAS_SIN_SUCURSAL: Vista[] = ["marketplaces", "tiendas", "tiktok", "google_ads", "chatgpt_ads", "canales_comparativa", "seo", "klaviyo", "campanas_ghl", "reputacion", "ml_bot", "bot_espejo", "compras_slp", "espejo_ventas", "parrilla", "marketplaces_abasto"];

// Reorden por departamentos (25-oct-2026, pedido de Gun; diseño con Codex en
// docs/brainstorm_reorden_radar_2026-10-25.md). Cada pantalla conserva su vista =
// su clave de permiso y su URL; solo cambió dónde vive en el menú y su nombre.
// Ventas reúne TODO lo comercial para Marinelda (Dirección de Ventas).
export const NAV: NavNodo[] = [
  { id: "hoy", label: "Hoy", icon: "i-grid", kind: "page", vista: "hoy" },
  { id: "ventas", label: "Ventas", icon: "i-store", kind: "folder",
    children: [
      { id: "v-atender", seccion: "Atender hoy", label: "Por atender", kind: "page", vista: "operacion", badge: "tabNAtender" },
      { id: "v-llamadas", seccion: "Atender hoy", label: "Llamadas", kind: "page", vista: "conmutador" },
      { id: "v-abandonos", seccion: "Atender hoy", label: "Seguimientos abandonados", kind: "page", vista: "abandonos" },
      { id: "v-riesgo", seccion: "Atender hoy", label: "Clientes en riesgo", kind: "page", vista: "clientes-riesgo", badge: "tabNRiesgo" },
      { id: "v-dormidos", seccion: "Atender hoy", label: "Clientes dormidos", kind: "page", vista: "clientes-dormidos", badge: "tabNDormidos" },
      { id: "v-resumen", seccion: "Resultados", label: "Resumen de leads", kind: "page", vista: "resumen" },
      { id: "v-embudo", seccion: "Resultados", label: "Embudo", kind: "page", vista: "embudo" },
      { id: "v-asesores", seccion: "Resultados", label: "Resultados por asesor", kind: "page", vista: "vendedores" },
      { id: "v-calidad", seccion: "Calidad y servicio", label: "Calidad de conversaciones", kind: "page", vista: "calidad", badge: "tabNCalidad" },
      { id: "v-redes", seccion: "Calidad y servicio", label: "Atención en redes", kind: "page", vista: "comunidad", badge: "tabNComunidad" },
      { id: "v-resenas", seccion: "Calidad y servicio", label: "Reseñas y quejas", kind: "page", vista: "reputacion" },
      { id: "v-talleres", seccion: "Calidad y servicio", label: "Talleres y degustaciones", kind: "page", vista: "talleres" },
      { id: "v-higiene", seccion: "Calidad y servicio", label: "Higiene del CRM", kind: "page", vista: "higiene", badge: "tabNHigiene" },
    ] },
  // Finanzas (26-oct-2026, migración 340): la venta y el margen por tienda, la
  // rentabilidad de marketplaces y las metas de venta son información financiera y
  // la ve SOLO quien tenga esos módulos (apagados por rol, encendidos por excepción
  // desde Usuarios; hoy, Gun). La carpeta no aparece a quien no tenga ninguno: los
  // placeholders no cuentan para mostrarla (ver `visible` en Shell.tsx).
  { id: "finanzas", label: "Finanzas", icon: "i-bag", kind: "folder",
    children: [
      { id: "fin-tiendas", seccion: "Rentabilidad", label: "Venta por tienda", kind: "page", vista: "tiendas" },
      { id: "fin-marketplaces", seccion: "Rentabilidad", label: "Marketplaces", kind: "page", vista: "marketplaces" },
      { id: "fin-metas", seccion: "Metas", label: "Metas de venta", kind: "page", vista: "metas_ventas" },
      { id: "fin-resumen", seccion: "Lo que viene", label: "Resumen financiero", kind: "placeholder",
        desc: "Ventas de todos los canales + margen + si cuadró la caja hoy, de un vistazo.",
        plan: ["Ventas de todos los canales + margen, de un vistazo", "Si cuadró la caja hoy (semáforo por sucursal)"] },
      { id: "fin-finanzas", seccion: "Lo que viene", label: "Reportes Financieros", kind: "placeholder", star: true,
        desc: "Indicador estrella de Gun: Balance operativo, Estado de Resultados y Control presupuestal, por sucursal.",
        plan: [
          "Balance operativo simplificado por sucursal (liquidez, apalancamiento)",
          "Estado de resultados completo: venta → margen bruto → nómina → mercadotecnia → logística → gastos fijos → gasto financiero → utilidad neta",
          "Control presupuestal: real vs. presupuesto (tabla de presupuestos nueva)",
          "Punto de equilibrio, ranking de sucursales, tendencia de margen neto, fuga de descuento",
          "Monitoreo de cuentas por cobrar y cuentas por pagar (agregado 2026-07-26)",
        ] },
    ] },
  { id: "marketing", label: "Marketing", icon: "i-target", kind: "folder",
    children: [
      { id: "mk-resumen", label: "Resumen", kind: "page", vista: "marketing_resumen" },
      { id: "mk-comparativa", label: "Comparativa de canales", kind: "page", vista: "canales_comparativa" },
      { id: "mk-meta", seccion: "Publicidad", label: "Meta", kind: "page", vista: "atribucion" },
      { id: "mk-google", seccion: "Publicidad", label: "Google", kind: "page", vista: "google_ads" },
      { id: "mk-tiktok", seccion: "Publicidad", label: "TikTok", kind: "page", vista: "tiktok" },
      { id: "mk-chatgpt", seccion: "Publicidad", label: "ChatGPT", kind: "page", vista: "chatgpt_ads" },
      { id: "mk-klaviyo", seccion: "Campañas", label: "Correo (Klaviyo)", kind: "page", vista: "klaviyo" },
      { id: "mk-ghl", seccion: "Campañas", label: "WhatsApp masivo", kind: "page", vista: "campanas_ghl" },
      // Contenido orgánico: lo que mercadotecnia planea en el sheet vs lo que sale en redes (22-oct-2026)
      { id: "mk-parrilla", seccion: "Contenido y búsqueda", label: "Parrilla de contenido", kind: "page", vista: "parrilla" },
      { id: "mk-seo", seccion: "Contenido y búsqueda", label: "SEO · Google", kind: "page", vista: "seo" },
    ] },
  { id: "operaciones", label: "Operaciones", icon: "i-shield", kind: "folder",
    children: [
      { id: "op-compras", label: "Compras y traspasos SLP", kind: "page", vista: "compras_slp" },
      // Espejo ML/Shopify → Bind (migración 321): lo vigila Vicky día a día.
      { id: "op-espejo", label: "Pedidos en línea → Bind", kind: "page", vista: "espejo_ventas" },
      // Stock real en Full (ML) y FBA (Amazon) vs venta de 30 días (migración 346): quién se acaba.
      { id: "op-abasto", label: "Abastecimiento Full y FBA", kind: "page", vista: "marketplaces_abasto" },
      // Oficina de agentes (2026-10-02, Fase 1, migración 226): los agentes de IA en vivo,
      // estilo videojuego. Entra quien tenga oficina / oficina_cedis / oficina_direccion.
      { id: "oficina", label: "Oficina de agentes", kind: "page", vista: "oficina" },
    ] },
  // Robots que contestan solos: los vigila Dirección, no son trabajo diario de Ventas
  { id: "robots", label: "Robots", icon: "i-robot", kind: "folder",
    children: [
      { id: "ml_bot", label: "Bot Mercado Libre", kind: "page", vista: "ml_bot" },
      { id: "bot_espejo", label: "Recepcionista IA (espejo)", kind: "page", vista: "bot_espejo" },
    ] },
];

// Lo que viene y aún no tiene datos (RH, almacén…): ya no ocupa el menú
// (Hoy lo enseña en gris, "sin vigilancia todavía"), pero sigue indexado para que
// /proximamente?id=… y los enlaces "qué viene" de Hoy funcionen. Los de Finanzas
// (fin-resumen, fin-finanzas) viven dentro de la carpeta Finanzas de NAV.
export const PLANES: NavNodo[] = [
  { id: "op-almacen", label: "Almacén", kind: "placeholder", desc: "Sin cambios de contenido — se queda 100% en Radar (solo mide/muestra).", plan: ["Contenido por definir con Gun"] },
  { id: "op-doble", label: "Doble Bodegaje", kind: "placeholder", desc: "Conciliación de stock CEDIS vs. sucursal.", plan: ["Diferencias de stock entre CEDIS y cada sucursal", "Alertas de descuadre por producto/sucursal"] },
  { id: "op-incidencias", label: "Incidencias", kind: "placeholder", desc: "Arbitraje de incidencias operativas.", plan: ["Registro y arbitraje de incidencias operativas por sucursal"] },
  { id: "op-camaras", label: "Cámaras", kind: "placeholder", desc: "Monitoreo con IA — vive completo en Radar, incluidas las 3 fases.", plan: ["3 fases completas, incluido el servidor de análisis de video (fase 2)"] },
  { id: "rh-resumen", label: "Resumen RH", kind: "placeholder",
        desc: "Sacado de Desempeño Operativo (2026-07-26) — RH ya tiene suficiente contenido propio para ser su propia carpeta, no solo una página suelta. PILOT opera (asistencias/evaluaciones); Radar solo muestra el resultado.",
        plan: ["Asistencia / retardos / faltas por empleado, de un vistazo (BioTime vía PILOT)", "Alertas de sucursal sin registros de entrada"] },
  { id: "rh-colaboradores", label: "Desempeño Colaboradores", kind: "placeholder",
        desc: "Ficha por colaborador — resultados de evaluaciones y ranking.",
        plan: ["Ficha individual por colaborador", "Resultados de evaluaciones de personal", "Ranking de mejor/peor calificados"] },
];

// ---------- índices calculados una sola vez a partir de NAV ----------
export const VISTA_A_NODO: Record<string, NavPage | NavTab> = {};
export const VISTA_A_GRUPO: Record<string, NavGroup> = {};
export const VISTA_A_TOP: Record<string, string> = {};
export const PLACEHOLDER_POR_ID: Record<string, NavPlaceholder> = {};
export const PLACEHOLDER_A_TOP: Record<string, string> = {};

function indexarNav(nodos: NavNodo[], topId: string | null): void {
  for (const n of nodos) {
    const top = topId ?? n.id;
    if (n.kind === "page") {
      VISTA_A_NODO[n.vista] = n;
      VISTA_A_TOP[n.vista] = top;
    } else if (n.kind === "group") {
      for (const t of n.tabs) {
        VISTA_A_NODO[t.vista] = t;
        VISTA_A_GRUPO[t.vista] = n;
        VISTA_A_TOP[t.vista] = top;
      }
    } else if (n.kind === "placeholder") {
      PLACEHOLDER_POR_ID[n.id] = n;
      PLACEHOLDER_A_TOP[n.id] = top;
    } else if (n.kind === "folder") {
      indexarNav(n.children, top);
    }
  }
}
indexarNav(NAV, null);
for (const p of PLANES) if (p.kind === "placeholder") PLACEHOLDER_POR_ID[p.id] = p;


// ---------- rutas legibles (una página por módulo) ----------
// La vista es la llave interna (y la llave de permisos en la base), pero en la
// URL se ve con guiones: /google-ads en vez de /google_ads. Se aceptan las dos
// formas al entrar, para no romper un enlace que alguien ya haya guardado.
export const rutaDe = (v: Vista): string => v.replace(/_/g, "-");

export const VISTA_DE_RUTA: Record<string, Vista> = (() => {
  const m: Record<string, Vista> = {};
  for (const v of VISTAS) {
    m[rutaDe(v)] = v;
    m[v] = v; // la forma vieja con guion bajo sigue funcionando
  }
  return m;
})();

// Los 4 destinos de la barra inferior en celular; el resto vive en "Más".
export const MOBILE_PRINCIPALES = ["hoy", "ventas", "marketing", "operaciones"];

/**
 * Primer destino del menú que este usuario sí puede ver, recorriendo NAV en
 * orden (app.js 304-308). Un rol sin permiso de Resumen debe aterrizar en su
 * primera pantalla real, no en un "Sin acceso". Los placeholders no cuentan:
 * son roadmap, no un destino con datos.
 */
export function primerDestinoVisible(puedeVer: (v: Vista) => boolean): Vista | null {
  const buscar = (nodos: NavNodo[]): Vista | null => {
    for (const n of nodos) {
      if (n.kind === "page" && puedeVer(n.vista)) return n.vista;
      if (n.kind === "group") {
        const t = n.tabs.find((tab) => puedeVer(tab.vista));
        if (t) return t.vista;
      }
      if (n.kind === "folder") {
        const v = buscar(n.children);
        if (v) return v;
      }
    }
    return null;
  };
  return buscar(NAV);
}
